import { TOOL_ICONS, type DockTool, type ToolId } from "./tools.js";

/**
 * Flat, mockup-faithful editor tool dock: a single scrolling row of icon tools
 * (Clips / Focus / Caption / Sound / Look / Motion …) with the active tool
 * highlighted — matches …/targets/nav-2-Editor.png.
 */
export function ToolDock({
  tools,
  active,
  onSelect,
}: {
  tools: DockTool[];
  active: ToolId;
  onSelect: (id: ToolId) => void;
}) {
  return (
    <nav className="tool-dock" data-testid="tool-dock" aria-label="Editing tools">
      <div className="tool-dock-row" data-testid="tool-tabs">
        {tools.map((t) => {
          const pressed = active === t.id;
          return (
            <button
              key={t.id}
              type="button"
              className={`tool-dock-card${pressed ? " active" : ""}${t.locked ? " locked" : ""}`}
              data-testid={`tool-tab-${t.id}`}
              aria-pressed={pressed}
              aria-label={t.lockReason ? `${t.label} (${t.lockReason})` : t.label}
              title={t.lockReason}
              disabled={Boolean(t.locked)}
              onClick={() => {
                if (t.locked) return;
                onSelect(t.id);
              }}
            >
              <span className="tool-dock-icon" aria-hidden data-tool={t.id}>
                {TOOL_ICONS[t.id]}
              </span>
              <span className="tool-dock-label">{t.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
